import React from 'react';
export function Footer() {
  return <footer className="bg-[#2C2416] text-[#FFF8E7] py-12 border-t border-[#FFF8E7]/10" data-id="element-36">
      <div className="container mx-auto px-4 text-center" data-id="element-37">
        <h2 className="text-4xl md:text-5xl mb-6" data-id="element-38">Duelistarena</h2>

        <div className="flex justify-center space-x-8 mb-8 font-serif italic text-[#FFF8E7]/70" data-id="element-39">
          <a href="#about" className="hover:text-[#D4735E] transition-colors" data-id="element-40">
            About
          </a>
          <a href="#menu" className="hover:text-[#D4735E] transition-colors" data-id="element-41">
            Menu
          </a>
          <a href="#location" className="hover:text-[#D4735E] transition-colors" data-id="element-42">
            Location
          </a>
        </div>

        <div className="w-full h-px bg-[#FFF8E7]/10 max-w-xs mx-auto mb-8" data-id="element-43" />

        <p className="font-serif text-sm text-[#FFF8E7]/40" data-id="element-44">
          © 2026 Duelistarena. All rights reserved.
        </p>
      </div>
    </footer>;
}